/* @generated */
import classnames from "classnames";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import { controlledHover, controlledFocus, controlledActive, hoverBefore, focusBefore, activeBefore, animated, ancestor, shadeClass, shadeTransition, shadeBg, shadeBgActive, shadeDuration } from "./withShade.css.esm.js";
import { vars } from "../../config/variables.esm.js";
const generateShadeBaseStyling = ({
  bgColors,
  duration = "Fast",
  style,
  direction = "up"
}) => {
  const _bgColors = {
    base: "Opacity Surface",
    active: "Opacity Surface - State 1",
    ...bgColors
  };
  const tpx = "transparent";
  return {
    className: classnames(shadeClass, shadeTransition[direction]),
    style: {
      ...style,
      ...assignInlineVars({
        [shadeBg]: _bgColors.base === tpx ? tpx : vars.Color[_bgColors.base],
        [shadeBgActive]: _bgColors.active === tpx ? tpx : vars.Color[_bgColors.active],
        [shadeDuration]: vars.Motion.Duration[duration]
      })
    }
  };
};
function withShadeAncestor({
  direction,
  duration,
  bgColors,
  style,
  state = "auto"
}) {
  const _classes = {
    default: "",
    hover: controlledHover,
    focus: controlledFocus,
    active: controlledActive,
    /* automatic classes that combine both hover, focus and base classes for each of use*/
    auto: classnames(hoverBefore, focusBefore, activeBefore),
    animated
  };
  const { style: _style, className: _baseClasses } = generateShadeBaseStyling({
    direction,
    duration,
    bgColors,
    style
  });
  return {
    className: classnames(_baseClasses, _classes[state]),
    ancestorClassName: ancestor,
    style: _style
  };
}
function withShade({
  direction = "up",
  duration = "Fast",
  state = "auto",
  bgColors,
  className,
  style
}) {
  const _classes = {
    default: "",
    hover: controlledHover,
    focus: controlledFocus,
    active: controlledActive,
    /* automatic classes that combine both hover, focus and base classes for each of use*/
    auto: classnames(hoverBefore, focusBefore, activeBefore),
    animated
  };
  const { style: _style, className: _baseClasses } = generateShadeBaseStyling({
    direction,
    duration,
    bgColors,
    style
  });
  return {
    className: classnames(_baseClasses, _classes[state], className),
    style: _style
  };
}
export {
  withShade,
  withShadeAncestor
};
